import Utils from "../../../utility";

const initialState = {
  cashbacks: [],
  count: 0,
  offset: 1,
  take: 20,
  search: "",
  order: "DESC",
  sortField: "updatedAt",
  fetched: false,
};

export const b2bCashbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case Utils.ActionName.B2B_CASHBACK:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
